import React from 'react';
import { Spin, Progress } from 'antd';
import styles from '../../components/common/Common.module.css';

const DataLoadingScreen = ({
  visible = false,
  percentage = null,
  text = 'Caricamento in corso...',
}) => {
  if (!visible) return null;
  return (
    <div className={styles.dataLoaderOverlay}>
      <div className={styles.dataLoaderCard}>
        <div className={styles.dataLoaderHeader}>
          <Spin size="large" />
          <h3 className={styles.dataLoaderText}>{text}</h3>
        </div>
        {percentage !== null && (
          <div className={styles.dataLoaderProgress}>
            <Progress
              percent={percentage}
              status="active"
              strokeColor={{ '0%': '#A1E430', '100%': '#8BC92A' }}
              trailColor="rgba(255, 255, 255, 0.1)"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataLoadingScreen;
